import { useToast } from '@app/util/hooks/useToast'
import { useClient } from '@based/sdk/react'
import { Initiative } from '@schema/initiative'
import { useCallback, useEffect } from 'react'

export const useInitiativeAutoSave = (
  initiativeId: number,
  initiative: Partial<Initiative>,
  debounceDelayInSeconds?: number,
) => {
  const debounceDelay = (debounceDelayInSeconds ?? 0.3) * 1000
  const client = useClient()
  const { showFailToast } = useToast()

  const saveCallback = useCallback(() => {
    client
      .call('edit-initiative', { id: initiativeId, value: initiative })
      .then((success) => {
        if (!success) {
          showFailToast()
        }
      })
      .catch(() => {
        showFailToast()
      })
  }, [client, initiativeId, initiative, showFailToast])

  useEffect(() => {
    if (Object.values(initiative).every((v) => !v)) {
      return
    }

    const delayTimer = setTimeout(() => {
      saveCallback()
    }, debounceDelay)

    return () => {
      clearTimeout(delayTimer)
    }
  }, [initiative, debounceDelay, saveCallback])
}
